import { createContext, useContext } from 'react';
import { MChatContact } from '@/src/modules/chat/models/chat-contact';
import { MChatConversation } from '@/src/modules/chat/models/chat-conversation';
import { MChatMessage } from '@/src/modules/chat/models/chat-message';
import { TChatTab } from '../_enums/chat-tab';

interface IMarketplaceCustomerChatContext {
  currentConversationContact: MChatContact | null;
  isGettingCurrentConversationContact: boolean;
  selfMedicationConversation: MChatConversation | null;
  complaintConversation: MChatConversation | null;
  sellerConversations: MChatConversation[];
  isGettingConversations: boolean;
  isGettingMoreConversations: boolean;
  isReachingEndConversations: boolean;
  selectedConversationId: number | null;
  setSelectedConversationId: (conversationId: number | null) => void;
  selectedConversation: MChatConversation | null;
  currentConversationMessages: MChatMessage[];
  loadMoreCurrentConversationMessages: () => void;
  addCurrentConversationMessages: (messages: MChatMessage) => void;
  isGettingCurrentConversationMessages: boolean;
  isGettingMoreCurrentConversationMessages: boolean;
  isReachingEndCurrentConversationMessages: boolean;
  loadMoreConversations: () => void;
  refreshConversations: () => void;
  isRefreshingConversations: boolean;
  createSelfMedicationConversation: () => void;
  isCreatingSelfMedicationConversation: boolean;
  currentOpenedTab: TChatTab;
  setCurrentOpenedTab: (tab: TChatTab) => void;
}

export const MarketplaceCustomerChatContext =
  createContext<IMarketplaceCustomerChatContext | null>(null);

export function useMarketplaceCustomerChatContext() {
  const context = useContext(MarketplaceCustomerChatContext);
  if (!context) {
    throw new Error(
      'useMarketplaceCustomerChatContext must be used within a MarketplaceCustomerChatProvider'
    );
  }

  return context;
}
